import {Component, Input, OnInit} from '@angular/core';
import {PlayerAggregationDTO} from '../../../services/api/api';

@Component({
  selector: 'sb-cull-preview',
  templateUrl: './sb-cull-preview.component.html',
  styleUrls: ['./sb-cull-preview.component.scss'],
  standalone: false,
})
export class SbCullPreviewComponent implements OnInit {
  @Input() playerAggregationData: PlayerAggregationDTO;

  constructor() {}

  ngOnInit(): void {}
}
